module.exports = __webpack_public_path__ + "img/why_img_1.e11f5c2f.png";